import React from 'react'
import { connect } from 'react-redux'

import AttractionActions from '../../Redux/AttractionRedux'
import FilesActions from '../../Redux/FilesRedux'

class FormChangeImage extends React.Component {

  /**
   * NOTE : IMAGE UPLOAD IN THIS COMPONENT IS DIFFERENT / NOT USING 'FILEUPLOADER' COMPONENT LIKE THE OTHERS
   * BECAUSE ON BACKEND, TO UPDATE ATTRACTION IMAGE IS ONLY NEED TO UPLOAD IT AND THEN AUTOMATICALLY CHANGED
   */

  constructor (props) {
    super (props)
    this.state = {
      file: null,
      passed: false, // to make sure it pass the data once, cause sometimes componentWillReceiveProps would trigger several times
      uploading: false, // trgigger 'uploading ...' text
      err: null, // to contain error,
      preview: null
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data && !this.state.passed) {
      this.setState({
        uploading: false,
        passed: true
      })
      this.props.closeModal()
    }

    if (newProps.files.err) {
      this.setState({ err: newProps.files.err, file: null })
    }
  }

  _fileUploaded = (file) => {
    this.setState({file})
  }

  _fileSelect = (event) => {
    const file = event.target

    let reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        preview: reader.result
      })
    }
    reader.readAsDataURL(event.target.files[0])
    this.setState({ file })
  }

  _upload = (event) => {
    this.setState({ uploading: true, passed: false })
    if (event) event.preventDefault()
    let data = new FormData()
    const files = event.target.files[0] || this.state.file.files[0]
    data.append('files', files)

    const { item } = this.props
    let filename = ''
    if (item) {
      filename = item.split('/')
      filename = filename[filename.length - 1]
      filename = filename.substring(0, filename.indexOf('?'))
    }
    const setting = {
      type: 'attraction-picture',
      attraction_id: this.props.attractionId,
      filename
    }
    Object.keys(setting).map((key) => (
      data.append(key, setting[key])
    ))
    
    this.props.upload(data)
  }

  render() {
    const { closeModal, dimension } = this.props

    return (
      <form onSubmit={(event) => this._upload(event)} className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Edit Attraction Image</h4>
        </div>
        <div className="form-group">
          <div>
            <div className="row">
              <div className="col-3">
                <label htmlFor="image" className="control-label">Image File (<span className="text-orange">{dimension}</span>)</label>
              </div>
              <div className="col-9">
                {/* <FileUploader setting={{ type: 'attraction-picture', attraction_id: this.props.attractionId, filename }} onUploaded={(filename) => this._fileUploaded(filename)}/> */}
                <div>
                  <div className="input-group">
                    <div className="custom-file">
                      <input type="file" name="files" required={this.props.required} className="custom-file-input" onChange={(event) => this._fileSelect(event)}/>
                      <label className="custom-file-label">
                        {this.state.file ? 'File selected' : 'Choose files'}
                      </label>
                    </div>
                    {/* <div className="input-group-append">
                      <button disabled={!this.state.file} type="button" className="input-group-text" onClick={(event) => this._upload(event)}>Upload</button>
                    </div> */}
                  </div>
                  { this.state.uploading && 'Uploading ...' }
                  {this.state.preview ?
                    <div>
                      {this.state.preview && 
                          <img alt={this.state.preview} className="img img-responsive" src={this.state.preview} style={{ maxWidth: '100%' }}/>
                      }
                    </div>
                    :
                    <div>
                      No Image To Preview
                    </div>
                  }
                  {this.state.err && <div className="alert alert-danger">{ this.state.err }</div>}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group d-flex justify-content-end">
          <button type="button" className={`btn btn-lg btn-secondary mr-2`} onClick={() => closeModal()}>Close</button>
          <button type="submit" className={`btn btn-lg btn-primary mr-2`}>Save</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data)),
  clearCache: () => dispatch(AttractionActions.attractionClearCacheRequest()),
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
})

export default connect(stateToProps, dispatchToProps)(FormChangeImage)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/FormChangeImage.js